<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasPorFormasDePago")}}</li>
                    </ol>
                </nav>
            </div>
            
            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
                :conTodosTodos="true"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">
                                    <strong>{{$t("negocio")}}</strong>
                                </label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="getTpvs()"
                                           :placeholder="$t('seleccionaNegocio')">

                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listTPV">
                                    <strong>{{$t("TPV")}}</strong>
                                </label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="idTpv"
                                           filterable
                                           @change="getFormasPago()"
                                           :placeholder="$t('seleccionaTpv')">
                                    <el-option v-for="tpv in listTpv"
                                               class="select-primary"
                                               :value="tpv.id"
                                               :label="tpv.nameShow"
                                               :key="tpv.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getFormasPago()" style="width: 100%;">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15"> {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="data.length > 0">
                    <div class="row">
                        <div class="justify-content-between div-export col-md-12 text-left" v-if="!formasPagosDets">
                            <div>
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <i v-tooltip.top-center="'Recuerda que las cantidades del excel son las cantidades totales con el descuento ya restado, debido a que para calcular los impuestos, hay que restar primero los descuentos.'"
                                    style="cursor: pointer; padding-left:5px; color:#1E22AA;"
                                    class="fa fa-info-circle">
                                </i>
                                <span class="text-secondary" style="float: right"><small>
                                    {{
                                        $t('recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo') 
                                    }}
                                    <br>
                                    <span style="float: right">{{$t('losDescuentosDeLasVentasEstanAlCeroDeIva')}}</span>
                                </small></span>

                            </div>
                        </div>

                        <div v-if="formasPagosDets" class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                <button class="btn btn-primary"
                                        @click="formasPagosDets=false"><i
                                        class="fas fa-arrow-circle-left"></i>
                                    {{$t("volver")}}
                                </button>
                                </div>
                                <div class="col-md-6 text-right">
                                <div class="justify-content-between div-export col-md-12 "
                                     v-if="formasPagosDets">
                                    <div>
                                        <el-dropdown>
                                            <el-button type="primary" size="small">
                                                <i class="fa fa-file"></i>
                                                {{$t("exportarInforme")}} <i
                                                    class="el-icon-arrow-down el-icon--right"></i>
                                            </el-button>
                                            <el-dropdown-menu slot="dropdown">
                                                <a :href="urlExportPdfTicket">
                                                    <el-dropdown-item class="text-danger">
                                                        <strong><i class="fa fa-file-pdf"></i>
                                                            {{$t("exportarPdf")}}</strong>
                                                    </el-dropdown-item>
                                                </a>
                                                <a :href="urlExportExcelTicket">
                                                    <el-dropdown-item class="text-success">
                                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                                    </el-dropdown-item>
                                                </a>
                                            </el-dropdown-menu>
                                        </el-dropdown>

                                    </div>
                                </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="formasPagosDets" class="col-md-12">
                            <template v-for="ticket in tickets">
                                <ticket :ticket="ticket"></ticket>
                            </template>
                        </div>
                        <div v-else class="col-md-12">
                            <div class="table-responsive" style="overflow: auto">
                                <table class="table table-bordered table-striped text-nowrap">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th>

                                            <span v-if="ordenarName"
                                                  @click="sortedArrayASC(1),ordenarName=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("formaDePago")}}
                                    </span>
                                            <span v-else @click="sortedArrayDESC(1), ordenarName=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("formaDePago")}}
                                    </span>

                                        </th>
                                        <th>

                                            <span v-if="ordenarNumComensales"
                                                  @click="sortedArrayASC(2),ordenarNumComensales=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("comensales")}}
                                    </span>
                                            <span v-else @click="sortedArrayDESC(2), ordenarNumComensales=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("comensales")}}
                                    </span>


                                        </th>
                                        <th>

                                            <span v-if="ordenarImpuesto"
                                                  @click="sortedArrayASC(5),ordenarImpuesto=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("total")}}
                                    </span>
                                            <span v-else @click="sortedArrayDESC(5), ordenarImpuesto=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("total")}}
                                    </span>

                                        </th>
                                        <th>{{$t("baseImponible")}}</th>
                                        <th>{{$t("totalImpuestoIva")}}</th>
                                        <th width="10%">{{$t("acciones")}}</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="obj in data">
                                        <td>{{obj.name }}</td>
                                        <td align="center">{{obj.numComensales}}</td>
                                        <td align="right">{{obj.amount | currency }}</td>
                                        <td align="right">{{getBaseFpago(obj.vatTypeBase) | currency }}</td>
                                        <td align="right">{{getCuotaFpago(obj.vatTypeCuota)| currency }}</td>
                                        <td align="center">
                                            <i v-tooltip.top-center="$t('verDesgloseDeImpuestos')"
                                                style="cursor: pointer; padding-right:15px"
                                                @click="getImpuestoPorFormaDePago(obj)"
                                                class="fa fa-info-circle">
                                            </i>
                                            <i v-tooltip.top-center="$t('desgloseFacturas')"
                                                style="cursor: pointer"
                                                @click="formasPagosDets=true, getFormasPagoDetails(obj.name,obj.idFormaPago)"
                                                class="fas fa-arrow-circle-right">
                                            </i>
                                        </td>
                                    </tr>

                                    <tr class="table-success">
                                        <td><strong>{{$t("total")}}</strong></td>
                                        <td align="center"><strong>{{getComensales}}</strong></td>
                                        <td align="right"><strong>{{getTotal | currency}}</strong></td>
                                        <td align="right"><strong>{{getBase2 | currency}}</strong></td>
                                        <td align="right"><strong>{{getImpuesto2 | currency}}</strong></td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHayVentasEnEsteRangoDeFechas")}}.
                    </div>
                </template>
            </div>
        </div>

        <modal
        name="desgloseModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="false"
        >
        <div>
            <div class="modal-header">
            <h4 style="margin: 0px">
                {{ $t("desgloseDeImpuestos") }}
                <sup>
                <i
                    v-tooltip.top-center="
                    $t('recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres') + $t('yQue') + $t('losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva')
                    "
                    class="fa fa-question-circle"
                ></i>
                </sup>
            </h4>
            </div>
            <div class="modal-body">
            <div
                class="table-responsive"
                style="overflow: auto"
            >
                <table class="table table-bordered table-striped ">
                <thead class="thead-dark">
                    <tr>
                    <th>{{ $t("tipoIva") }}</th>
                    <th>{{ $t("base") }}</th>
                    <th>{{ $t("impuesto") }}</th>
                    <th>{{ $t("importe") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ref, index) in desgloseSeleccionado.vatType">
                        <td>{{ desgloseSeleccionado.vatType[index] }} %</td>
                        <td>{{ desgloseSeleccionado.vatTypeBase[index] | currency }}</td>
                        <td>{{ desgloseSeleccionado.vatTypeCuota[index] | currency }}</td>
                        <td align="right">{{ desgloseSeleccionado.vatTypeAmount[index] | currency }}</td>
                    </tr>

                    <tr class="table-success">
                        <td>
                            <strong>{{ $t("total") }}:</strong>
                        </td>
                        <td></td>
                        <td></td>
                        <td align="right">
                            <strong>{{ desgloseSeleccionado.amount | currency }}</strong>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr></tr>
                </tfoot>
                </table>
            </div>
            </div>
            <div class="modal-footer">
            <button class="btn btn-default" @click="cerrarModal()">
                <i class="fa fa-times-circle"></i>
                {{ $t("volver") }}
            </button>
            </div>
        </div>
        </modal>

    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import Datetime from 'vue-datetime'
    import Ticket from '../../../Widgets/Ticket.vue'
    import { mapState } from 'vuex'
    import { log } from 'mathjs';

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t("formasDePago"));
            this.getBusiness();


            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }
        },
        components: {
            //CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            // [Datetime]: Datetime,
            [Option.name]: Option,
            CabeceraInformes,
            'ticket': Ticket
        },
        data() {
            return {
                loading: null,
                listBusinesses: [],
                listTpv: [],
                idTpv: -1,
                dates: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                idBusiness: 0,
                data: [''],
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),

                tickets: [],
                formasPagosDets: false,
                desgloseSeleccionado: '',


                //ORDENAR

                ordenarName: 0,
                ordenarNumComensales: 0,
                ordenarBase: 0,
                ordenarImpuesto: 0,
                ordenarTotal: 0,

                respuesta: true,


                //EXPORTAR TICKETS
                idFormaPago:0,
                tipo:0,


            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/formaspago/exportFormasPagoSales/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&allowAllBusiness=true"
            },
            urlExportExcel() {

                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/formaspago/exportFormasPagoSales/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&allowAllBusiness=true"

            },

            urlExportPdfTicket() {

                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/formaspago/exportFormasPagoTicket/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&tipo=" + this.tipo + "&idFormaPago=" + this.idFormaPago + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcelTicket() {

                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/formaspago/exportFormasPagoTicket/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&tipo=" + this.tipo + "&idFormaPago=" + this.idFormaPago + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },

            getComensales() {
                let comensales = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        comensales += d.numComensales || 0;
                    });
                }
                return Math.round(comensales);
            },
            getBase() {
                let total = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        total += d.amount || 0;
                    });
                }
                return (parseFloat(total) / 1.10);
            },
            getIVA() {
                let total = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        total += (parseFloat(d.amount || 0) / 1.10) * 0.10;
                    });
                }
                return total;
            },
            getTotal() {
                let total = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        total += d.amount || 0;
                    });
                }
                return total;
            },
            getBase2() {
                let total = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        if (Array.isArray(d.vatTypeBase)) {
                            d.vatTypeBase.forEach(v => total += v);
                        }
                    });
                }
                return total;
            },
            getImpuesto2() {
                let total = 0;
                if (Array.isArray(this.data)) {
                    this.data.forEach(d => {
                        if (Array.isArray(d.vatTypeCuota)) {
                            d.vatTypeCuota.forEach(v => total += v);
                        }
                    });
                }
                return total;
            },
        },
        methods: {
            getBaseFpago(listBase) {
                let total = 0;
                if (Array.isArray(listBase)) {
                    for (let i = 0; i < listBase.length; i++) {
                        total += listBase[i];
                    }
                }
                return total;
            },
            getCuotaFpago(listCuota) {
                let total = 0;
                if (Array.isArray(listCuota)) {
                    for (let i = 0; i < listCuota.length; i++) {
                        total += listCuota[i];
                    }
                }
                return total;
            },
            getImpuestoPorFormaDePago(formaPago) {
                this.desgloseSeleccionado = formaPago;

                this.$modal.show("desgloseModal");
            },

            cerrarModal() {
                this.$modal.hide("desgloseModal");
            },
            
            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }

                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.list = [];
                this.cambioTpv()
            },
            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                this.getFormasPago();
            },
            cambioTpv(idTpvData, filtrar) {
                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                }
                this.emitirConsulta();
            },
            cambioHora(dates) {
                this.datefrom = dates[0];
                this.dateto = dates[1];
            },

            sortedArrayASC: function (nameAtributo) {

                switch (nameAtributo) {

                    case 1:

                        this.ordenarName = 1;

                    function compareName(a, b) {

                        const nameA = (a.name || "").toUpperCase();
                        const nameB = (b.name || "").toUpperCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    }

                        return this.data.sort(compareName);

                    case 2:

                        this.ordenarNumComensales = 1;

                    function compareNumComensales(a, b) {

                        if (a.numComensales < b.numComensales)
                            return -1;
                        if (a.numComensales > b.numComensales)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareNumComensales);

                    case 3:

                        this.ordenarBase = 1;

                    function compareBase(a, b) {

                        if (a.amount < b.amount)
                            return -1;
                        if (a.amount > b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareBase);

                    case 4:

                        this.ordenarImpuesto = 1;

                    function compareImpuesto(a, b) {

                        if (a.amount < b.amount)
                            return -1;
                        if (a.amount > b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareImpuesto);


                    case 5:

                        this.ordenarTotal = 1;

                    function compareTotal(a, b) {

                        if (a.amount < b.amount)
                            return -1;
                        if (a.amount > b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareTotal);


                }

            },
            sortedArrayDESC: function (nameAtributo) {

                switch (nameAtributo) {

                    case 1:

                        this.ordenarName = 0;

                    function compareName(a, b) {
                        const nameA = (a.name || "").toUpperCase();
                        const nameB = (b.name || "").toUpperCase();
                        if (nameA > nameB) return -1;
                        if (nameA < nameB) return 1;
                        return 0;
                    }

                        return this.data.sort(compareName);

                    case 2:

                        this.ordenarNumComensales = 0;

                    function compareNumComensales(a, b) {
                        if (a.numComensales > b.numComensales)
                            return -1;
                        if (a.numComensales < b.numComensales)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareNumComensales);

                    case 3:

                        this.ordenarBase = 0;

                    function compareBase(a, b) {
                        if (a.amount > b.amount)
                            return -1;
                        if (a.amount < b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareBase);

                    case 4:

                        this.ordenarImpuesto = 0;

                    function compareImpuesto(a, b) {
                        if (a.amount > b.amount)
                            return -1;
                        if (a.amount < b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareImpuesto);


                    case 5:

                        this.ordenarTotal = 0;

                    function compareTotal(a, b) {
                        if (a.amount > b.amount)
                            return -1;
                        if (a.amount < b.amount)
                            return 1;
                        return 0;
                    }

                        return this.data.sort(compareTotal);


                }

            },


            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;


                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getTpvs();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getTpvs() {

                if (this.idBusiness.length > 0) {

                    this.listTpv = [];

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                        .then(function (response) {
                            if (response.data.response) {

                                /*let tpv = {
                                    nameShow: vm.$t('todos'),
                                    id: 0
                                };
                                vm.listTpv.push(tpv);*/

                                for (let i = 0; i < response.data.result.length; i++) {
                                    let tpv = {
                                        nameShow: response.data.result[i].nameShow,
                                        id: response.data.result[i].id
                                    };
                                    vm.listTpv.push(tpv)
                                    vm.idTpv = -1;
                                }

                                vm.getFormasPago();
                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },

            getFormasPago() {
                if (this.datefrom === null || this.dateto === null) {

                    this.loading.close();

                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();
                   // console.log(secondsDesde);
                   // console.log(secondsHasta);
                    if (secondsHasta < secondsDesde) {

                        this.loading.close();

                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);
                        
                        

                        let idTpvAMandar = "";
                        if (this.idTpv == -1) {
                            idTpvAMandar = 0;
                        } else {
                            idTpvAMandar = this.idTpv;
                        }

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idTpv: idTpvAMandar,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt,
                                allowAllBusiness: true
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "formaspago/getFormasPagoSales", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.data = response.data.result;
                                  //  console.log(vm.data);
                                    vm.respuesta = true;

                                }else if (response.data.response == false && response.data.rangoMayor == true) {

                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });

                                    vm.respuesta = false;
                                } else {

                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });


                                    vm.respuesta = false;
                                }

                                vm.loading.close();
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            getFormasPagoDetails(tipo, idFormaPago) {

                this.idFormaPago=idFormaPago;

                this.tipo=tipo;

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);


                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idTpv: this.idTpv,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt,
                                tipo: tipo,
                                idFormaPago: idFormaPago,
                                allowAllBusiness: true
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };


                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "formaspago/getFormasPagoDetails", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.tickets = response.data.result;
                                } else {

                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                }

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }

            }

        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    th span {

        cursor: pointer;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/FormasPago.vue